import React from 'react';

import { Box } from '@opendoor/atoms/box';
import { cn } from '@opendoor/atoms/utils';

interface LoginSectionProps {
  showLogin: boolean;
  onPress?: () => void;
  // When true, render the link in the inverse (light) foreground for use over a
  // dark/transparent header; otherwise use the primary foreground.
  inverse?: boolean;
}

export const LoginSection: React.FC<LoginSectionProps> = ({ showLogin, onPress, inverse }) => {
  if (!showLogin) return null;

  // A header nav link (not inline prose), so use Box href rather than Atoms Link
  // (whose inline variant adds underline/accent styling). `!` beats the global `a` color.
  return (
    <Box
      href="#"
      onClick={onPress}
      analyticsName="cosmos-sign-in"
      aria-label="Sign in to your account"
      className={cn(
        'w-max cursor-pointer font-medium no-underline',
        inverse ? 'text-od-content-inverse-primary!' : 'text-od-content-primary!',
      )}
    >
      Sign in
    </Box>
  );
};
